import * as React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { withClientState } from "apollo-link-state";
import { InMemoryCache } from "apollo-cache-inmemory";

import "./App.css";
import LoginPage, { ForgotForm, SetPasswordForm } from "./screens/Login";
import ProfilePage from "./screens/Profile";
import ListUsersPage from "./screens/AllUsers";
import IndexPage from "./screens/Home";
import { authToken } from "./resolvers/authToken";
import { ApolloLink } from "apollo-link";
import AuthRoute from "./components/AuthRoute";
import Route from "./components/LayoutRoute";
import AuthProvider from "./components/AuthProvider";
import Auth from "./services/Auth";
import { Redirect } from "react-router";
import NotFound from "./screens/NotFound";
import MainLayout from "./components/MainLayout";
import UserPage from "./screens/User";
import Token from "./screens/Token";
import OrdersPage from "./screens/Orders";
import RolesPage from "./screens/Roles";
import RolePage from "./screens/Role";
import MailingListsPage from "./screens/MailingLists";
import MailingListPage from "./screens/MailingList";

//const logo = require("./logo.svg");

const httpLink = new HttpLink({ uri: "/graphql" });

const authService = new Auth();

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = authService.token;
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const cache = new InMemoryCache();

const stateLink = withClientState({
  resolvers: authToken,
  cache: cache
});

const client = new ApolloClient({
  link: ApolloLink.from([stateLink, authLink, httpLink]),
  cache: cache
});

class App extends React.Component {
  render() {
    return (
      <AuthProvider apollo={client} service={authService}>
        <ApolloProvider client={client}>
          <Router>
            <Switch>
              <AuthRoute
                exact={true}
                path="/"
                component={IndexPage}
                layout={MainLayout}
              />
              <AuthRoute anonOnly={true} path="/login" component={LoginPage} />
              <AuthRoute
                anonOnly={true}
                path="/forgot"
                component={ForgotForm}
              />
              <AuthRoute
                anonOnly={true}
                path="/set-password"
                component={SetPasswordForm}
              />
              <AuthRoute
                path="/me"
                component={ProfilePage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="users"
                redirect="/"
                path="/users/add"
                component={UserPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="users"
                redirect="/"
                path="/users/:userId"
                component={UserPage}
                layout={MainLayout}
              />

              <AuthRoute
                scope="users"
                redirect="/"
                path="/users"
                component={ListUsersPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="users"
                redirect="/"
                path="/roles/add"
                component={RolePage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="users"
                redirect="/"
                path="/roles/:roleName"
                component={RolePage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="users"
                redirect="/"
                path="/roles"
                component={RolesPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="orders"
                path="/orders"
                component={OrdersPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="mail-list"
                path="/mailinglists/add"
                component={MailingListPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="mail-list"
                path="/mailinglists/:id"
                component={MailingListPage}
                layout={MainLayout}
              />
              <AuthRoute
                scope="mail-list"
                path="/mailinglists"
                component={MailingListsPage}
                layout={MainLayout}
              />
              <Route path="/t/:token" component={Token} />
              <Route path="/404" component={NotFound} />
              <Redirect to="/404" />
            </Switch>
          </Router>
        </ApolloProvider>
      </AuthProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx